import { generatePath } from "react-router";
export function buildRouteUrlWithQuery(pathTemplate, routeParams, queryParams = {}) {
    const path = generatePath(pathTemplate, routeParams);
    const query = new URLSearchParams(queryParams).toString();
    return query ? `${path}?${query}` : path;
}
